export const tagColorMap = {
    purple: "#a855f7",
    orange: "#f97316",
    blue: "#3b82f6",
    emerald: "#10b981",
};
